import { FormattedRecipe } from '@library/menu-service/queries/menuApiRecipes/types'

import { useIsOptimizelyFeatureEnabled } from 'containers/OptimizelyRollouts'
import { useMenu } from 'routes/Menu/domains/menu'
import Cookies from 'utils/GoustoCookies'

// The following cookie names are shortened to use as little space as possible while still being descriptive
type RecipeCustomisationPaintedDoorCookieName = 'dblPrtnPdOff' | 'addChknPdOff'

export const DOUBLE_PROTEIN_PAINTED_DOOR_SEEN_COOKIE_NAME: RecipeCustomisationPaintedDoorCookieName =
  'dblPrtnPdOff'
export const ADD_CHICKEN_BREAST_PAINTED_DOOR_SEEN_COOKIE_NAME: RecipeCustomisationPaintedDoorCookieName =
  'addChknPdOff'

export function getCookieNameByDietType(
  dietType: FormattedRecipe['attributes']['diet_type'],
): RecipeCustomisationPaintedDoorCookieName | null {
  const dietTypeSlug = dietType?.slug

  if (dietTypeSlug === 'vegetarian' || dietTypeSlug === 'vegan') {
    return ADD_CHICKEN_BREAST_PAINTED_DOOR_SEEN_COOKIE_NAME
  } else if (dietTypeSlug === 'meat' || dietTypeSlug === 'fish') {
    return DOUBLE_PROTEIN_PAINTED_DOOR_SEEN_COOKIE_NAME
  }

  return null
}

/**
 * Returns true if Add A Protein painted door experiment is enabled.
 */
export const useIsAddAProteinPaintedDoorEnabled = (
  recipeId: string,
  categoryId: string,
  dietType: FormattedRecipe['attributes']['diet_type'],
): boolean => {
  const isFeatureEnabled = useIsOptimizelyFeatureEnabled(
    'radishes_add_a_protein_painted_door_enabled',
  )
  const { getAlternativeOptionsForRecipe } = useMenu()
  const recipeWithAlternativeOptions = getAlternativeOptionsForRecipe({
    categoryId,
    recipeId,
    isOnDetailScreen: false,
  })
  const noRecipeVariants = recipeWithAlternativeOptions.length <= 1

  const cookieName = getCookieNameByDietType(dietType)
  if (!cookieName) {
    return false
  }

  // Negate the existence of the recipe customisation painted door cookie
  // We only want to show the experiment ONCE per customer per browser
  const cookieNotSet = !Cookies.get(cookieName)

  return !!(isFeatureEnabled && cookieNotSet && noRecipeVariants)
}
